import createClient from 'openapi-fetch'
import type { Client } from 'openapi-fetch'
import type { paths as marketPlaceApiTypes } from '~/types/api/marketplace-api-types'
import type { paths as placesApiTypes } from '~/types/api/places-api-types'

export default () => {
  const $config = useRuntimeConfig().public

  const marketPlaceApiClient = ref<Client<marketPlaceApiTypes> | undefined>()
  const placeApiClient = ref<Client<placesApiTypes> | undefined>()

  const getMarketplaceApiClient = () => {
    if (marketPlaceApiClient.value) return marketPlaceApiClient.value

    const cli = createClient<marketPlaceApiTypes>({
      baseUrl: $config.app.marketplace.apiEndpoint
    })

    marketPlaceApiClient.value = cli
    return cli
  }

  const getPlacesApiClient = () => {
    if (placeApiClient.value) return placeApiClient.value

    const cli = createClient<placesApiTypes>({
      baseUrl: $config.app.places.apiEndpoint
    })

    placeApiClient.value = cli
    return cli
  }

  return {
    getMarketplaceApiClient,
    getPlacesApiClient
  }
}
